<template>
  <v-app>
    <v-navigation-drawer app clipped permanent v-if="mode == 'bedrijfsadmin'">
      <v-list nav>

        <v-list-item link :to="{ name: 'bedrijfbewijzen' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-lock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Bewijzen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'bedrijfgebruikers' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Gebruikersbeheer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'bedrijfsrapportage' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-chart-box</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Gezamelijk rapporteren</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'tagbeheerbedrijf' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-tag</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Gedeelde tags</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link :to="{ name: 'kaarttypebeheerbedrijf' }">
          <v-list-item-icon>
            <v-icon color="primary">mdi-card-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Gedeelde bewijstypes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item link @click="switchmode">
          <v-list-item-icon>
            <v-icon color="primary">mdi-swap-horizontal</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Gebruikermodus</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>



    <v-app-bar app light clipped-left color="#FFF" :height="platform == 'ios' ? '90' : '56'"
      :class="{ iosAppbar: platform == 'ios' }">
      <v-btn icon disabled v-if="$route.meta.auth"> </v-btn><!-- tbv centreren logo -->
      <v-spacer></v-spacer>
      <v-img src="/2021_bouwbewiijs_logo.png" max-height="50" max-width="235" contain></v-img>

      <v-spacer></v-spacer>

      <v-menu offset-y bottom right v-if="$route.meta.auth">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-subheader v-if="appinfo">Ingelogd als {{ appinfo.Gebruiker }}</v-subheader>
          <v-list-item :to="{ name: 'account' }" dense>
            <v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
            <v-list-item-title>Account</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'licentie' }" dense>
            <v-list-item-icon><v-icon>mdi-file-sign</v-icon></v-list-item-icon>
            <v-list-item-title>Licentie</v-list-item-title>
          </v-list-item>
          <v-list-item :to="{ name: 'info' }" dense>
            <v-list-item-icon><v-icon>mdi-information-outline</v-icon></v-list-item-icon>
            <v-list-item-title>Over Bouwbewijs</v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout" dense>
            <v-list-item-icon><v-icon>mdi-exit-to-app</v-icon></v-list-item-icon>
            <v-list-item-title>Uitloggen</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container>
        <v-alert v-if="omgeving != ''" color="warning" text icon="mdi-information"> {{ omgeving }}-omgeving</v-alert>
        <router-view />

        <v-dialog v-model="offlineMsg" max-width="400">
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Geen verbinding
            </v-card-title>
            <v-card-text class="mt-2">
              Er is geen verbinding met de server mogelijk of er is iets anders
              mis. Mogelijk ben je offline. Probeer deze actie opnieuw als je
              online bent.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="offlineMsg = false">
                sluiten
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>

    <v-bottom-navigation color="secondary" grow light app :min-height="platform == 'ios' ? 80 : null" v-if="$route.meta.auth &&
      ($route.meta.hidenav == null || $route.meta.hidenav == false) && mode == 'gebruiker'
      ">
      <v-btn :to="{ name: 'mijnbewijzen' }" exact>
        <span>Mijn bewijzen</span>
        <v-icon>mdi-lock</v-icon>
      </v-btn>
      <v-btn :to="{ name: 'rapporten' }" v-if="!appinfo.GroteRapporten">
        <span>Rapporteren</span>
        <v-icon>mdi-chart-box</v-icon>
      </v-btn>
      <v-btn :to="{ name: 'rapportenExt' }" v-if="appinfo.GroteRapporten">
        <span>Rapporteren</span>
        <v-icon>mdi-chart-box-plus-outline</v-icon>
      </v-btn>
      <v-btn :to="{ name: 'instellingen' }">
        <span>Beheer</span>
        <v-icon>mdi-cog</v-icon>
      </v-btn>
      <v-btn @click="switchmode" v-if="this.platform == 'web' && mode == 'gebruiker' && appinfo.Bedrijfsadmin">
        <span>Bedrijfsbeheer</span>
        <v-icon>mdi-swap-horizontal</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </v-app>
</template>

<script>
import { Capacitor } from "@capacitor/core";
import { Network } from '@capacitor/network';

export default {
  name: "App",

  data: () => ({
    omgeving: process.env.VUE_APP_OMGEVING_INFO,
    appinfo: { Gebruiker: "onbekend" },
    platform: Capacitor.getPlatform(),
    offlineMsg: false,
    refreshmode: 0,
    tmpLocalData: ""
  }),
  methods: {
    getAppInfo: async function () {
      try {
        const online = sessionStorage.getItem("online") == "true";
        if (!online) {
          // Gebruiker is offline, appinfo-data lokaal bepalen.
          this.appinfo = { Gebruiker: "Offline", Bedrijfsaccount: false, Bedrijfsadmin: false, Versie: process.env.VUE_APP_VERSION, GroteRapporten: false };
          return;
        }
        let response = (await this.$api().Common_pAppVersie()).data;
        if (response == null || response.length == 0)
          await this.$confirm("Geen geldige licentie gevonden.", { buttonFalseText: "Sluiten", buttonTrueText: null });
        this.appinfo = response[0];
        this.appinfo.Versie = process.env.VUE_APP_VERSION
      } catch (ex) { await this.$confirm("Fout: " + ex.toString(), { buttonFalseText: "Sluiten", buttonTrueText: null }); }
    },
    switchmode: function () {
      if (this.mode == "gebruiker") {
        localStorage.setItem("bedrijfsmode", "bedrijfsadmin")
        this.$router.push({ name: "bedrijfbewijzen" });
      }
      else {
        localStorage.setItem("bedrijfsmode", "gebruiker");
        this.$router.push({ name: "mijnbewijzen" });
      }
      this.refreshmode++;
    },
    logout: function () {
      sessionStorage.removeItem("session-id");
      localStorage.removeItem("bouwbewijs-auth");
      this.$api().updateHeaders();
      this.$api2().updateHeaders();
      this.$router.push({ name: "aanmelden" });
      this.getAppInfo();
    },
    appOffline: function () {
      this.offlineMsg = true;
    },
    saveLookupsLocal: async function () {
      const online = sessionStorage.getItem("online") == "true";
      if (!online) {
        console.log("saveLookupsLocal niet van toepassing indien offline.");
        return; // Als we niet online zijn dan heeft dit geen zin.
      }
    },
    goOnline: function () {
      const online = sessionStorage.getItem("online") == "true";
      if (!online) {
        alert("Je bent nog offline, reconnecten lukt niet.");
        return;
      }

      let lsCred = JSON.parse(
        this.$helpers.crDec(localStorage.getItem("bouwbewijs-auth"))
      );

      if (lsCred) {
        this.$api()
          .Login({ Username: lsCred.username, Password: lsCred.password })
          .then((response) => {
            // Inloggen gelukt 
            sessionStorage.setItem("session-id", response.data.Token);
            localStorage.setItem("username", lsCred.username);
            this.$api().updateHeaders();
            this.$api2().updateHeaders();
            this.$root.$emit("login");
            // Is licentie nog geldig? 
            this.$api()
              .Licentie_pLicGeldig()
              .then((response) => {
                if (response.data[0].Result) this.redirect(); // Licentie is geldig 
                else this.$router.push({ name: "licentie" }); // Licentie is verlopen => naar licentiepagina 
              })
              .catch(() => { });
          })
          .catch(() => {
            alert("Inloggen misluk. Wachtwoord inmiddels gewijzigd? (doorsturen naar loginscherm)");
          });
      } else {
        alert("Geen locale credentials aanwezig, automatisch inloggen gaat niet (doorsturen naar loginscherm)");
      }
    }

  },
  computed: {
    mode: function () {
      this.refreshmode;
      if (this.platform == null || this.platform != "web")
        return "gebruiker"; // op mobile altijd gebruikersmode
      if (this.appinfo == null || !this.appinfo.Bedrijfsadmin)
        return "gebruiker"; // Als je geen bedrijfsadmin bent dan altijd gebruikersmode
      const localstoragemode = localStorage.getItem("bedrijfsmode");
      if (localstoragemode == null || localstoragemode == "")
        return "bedrijfsadmin"; // Als er geen localstorage-waarde is vastgelegd en je bent admin dan altijd admin
      return localstoragemode; // Waarde uit localstorage pakken
    },
  },
  watch: {
  },
  mounted: async function () {
    sessionStorage.setItem("online", (await Network.getStatus()).connected);
    Network.addListener('networkStatusChange', status => {
      //sessionStorage.setItem("online", status.connected)
      sessionStorage.setItem("onlineStatus", status.connected);
      sessionStorage.setItem("online", true); // Nug nog geen ondersteuning voor offline.
    });

    this.getAppInfo();
    this.$root.$on("login", this.getAppInfo);
    this.$root.$on("logout", this.getAppInfo);
    this.$root.$on("offline", this.appOffline);

  },
};
</script>

<style>
.v-application {
  font-family: "Fira Sans", sans-serif !important;
}

.iosAppbar {
  padding-top: 15px;
}

/* Fix voor bug dat in production build de knoppen voor bottom-navigation on top worden uitgelijnd. */
.v-item-group.v-bottom-navigation .v-btn {
  height: inherit !important;
}

.v-card__text,
.v-card__title {
  word-break: normal !important;
}
</style>